import PropTypes from 'prop-types';
import _ from 'lodash';
import getSlug from 'speakingurl';

import { Dropdown } from '../shared';
import useResponsive from '../../../utils/responsive';

const FaqDropdown = (props) => {
    const { sections } = props;
    const { isMobile, isTablet } = useResponsive();
    const defaultVal = getSlug(sections[0].section_header);

    const getSectionHeader = () => {
        const options = [];
        _.forEach(sections, (section) => {
            const headerName = _.get(section, 'section_header');
            const headerNameSlug = getSlug(headerName);
            options.push({
                label: headerName,
                value: headerNameSlug,
                id: `${headerNameSlug}-select`,
            });
        });
        return options;
    };

    if (isMobile || isTablet) {
        return (
            <div>
                <Dropdown
                    selectId="mobile-selection-dropdown"
                    options={getSectionHeader()}
                    defaultValue={defaultVal}
                    isLink
                    variant="standard"
                />
            </div>
        );
    }
    return null;
};

export default FaqDropdown;

FaqDropdown.propTypes = {
    sections: PropTypes.array,
};
